export default "__VITE_ASSET__BhjBQ_7C__"